import React from 'react';
import {connect} from 'react-redux';
import store from '../store';
import * as actions from '../actions/matchManagement';

export function playerTeeScore(props){
    function updateTeeScore(e){
        /*No value for "gameroom" being set when joing room. But is set
        * when creating a new room. This is why it works for creators but
        * not users who joined.*/
        console.log(store.getState());
        store.dispatch(actions.updateTeeScoreSocket(
            props.socket,
            props.gameroom,
            props.gamertag,
            props.teeNum,
            e.target.value
        ));
    }

    function increaseScoreBtnPress(e){
        e.preventDefault();
        console.log('Temp: Increase Tee Score to '+(props.teeScore+1));

        store.dispatch(actions.updateTeeScoreSocket(
            props.socket,
            props.gameroom,
            props.gamertag,
            props.teeNum,
            props.teeScore+1
        ));
    }

    function decreaseScoreBtnPress(e){
        e.preventDefault();
        console.log('Temp: Decrease Tee Score to '+(props.teeScore-1));

        store.dispatch(actions.updateTeeScoreSocket(
            props.socket,
            props.gameroom,
            props.gamertag,
            props.teeNum,
            props.teeScore-1
        ));
    }

    return(
        <div style={{
            backgroundColor: "#f2fbdd",
            margin: ".2rem",
            paddingTop: ".35rem",
            paddingBottom: ".35rem"
        }}>
            <input type="number" placeholder={props.teeScore} value={props.teeScore} className="btnStretch" style={{display: 'inline'}} onChange={e=>updateTeeScore(e)}/>
            <button style={{marginLeft: "1rem"}} onClick={e=>{increaseScoreBtnPress(e)}}> + </button>
            <button onClick={e=>{decreaseScoreBtnPress(e)}}> - </button>
            <h6 style={{display: 'inline', marginLeft: "1.5rem"}}>{props.gamertag}</h6>
        </div>
    );
}

const matStateToProps = state => ({
    gameroom: state.match.gameroom
});

export default connect(matStateToProps)(playerTeeScore)



// WEBPACK FOOTER //
// ./src/comps/playerTeeScore.js